export const roleDictionary = [
    { key: 1, value: 'Agent' },
    { key: 2, value: 'Junior Manager' },
    { key: 3, value: 'General manager' },
    { key: 4, value: 'Head Of Sales' },
    { key: 5, value: 'Director' },
    { key: 6, value: 'Training' },
    { key: 7, value: 'Admin' },
    { key: 8, value: 'Support' },
    { key: 9, value: 'Facilities' },
    { key: 11, value: 'Back Office' },
    { key: 12, value: 'Feeder Junior Manager' }
];

const requestTypeDictionary = [
    {
        key: 'usersMovementApproval',
        title: "Approve user movement",
        description: "Approve a request to move a user or team"
    },
    {
        key: 'usersCreation',
        title: "User Creation Request",
        description: "Create a request to create new user or team"
    },
    {
        key: 'userToRemove',
        title: "User Removal Request",
        description: "Create a request to remove a user"
    },
    {
        key: 'userCampaignUpdate',
        title: "Agent Campaign Update",
        description: "Move an agent/s to a new campaign"
    },
    {
        key: 'managerCampaignUpdate',
        title: "Junior Manager Campaign Update",
        description: "Add/remove campaigns to junior managers / trainers"
    },
    {
        key: 'campaignCreation',
        title: "Campaign Creation",
        description: "Create a new campaign"
    },
    {
        key: 'campaignEscalation',
        title: "Agent Campaign Escalation",
        description: "Create a request to resolve the campaign escalation"
    },
    {
        key: 'managerEscalation',
        title: "Agent Manager Escalation",
        description: "Create a request to resolve the manager escalation"
    },
    {
        key: 'usersMovementRequest',
        title: "User Movement Request",
        description: "Create a request to move a user or team"
    },
    {
        key: 'updateAgentPersalInformation',
        title: "Update Agent Persal Information",
        description: "Create a request to create / update a user's persal information"
    }
];

const requestTypeAccessByRole = [
    {
        role: 'Junior Manager',
        allowedRequests: ['usersMovementRequest', 'userCampaignUpdate']
    },
    {
        role: 'Feeder Junior Manager',
        allowedRequests: ['usersMovementRequest', 'userCampaignUpdate']
    },
    {
        role: 'General Manager',
        allowedRequests: ['usersMovementRequest', 'userCampaignUpdate', 'managerCampaignUpdate']
    },
    {
        role: 'Feeder General Manager',
        allowedRequests: ['usersMovementRequest', 'userCampaignUpdate', 'managerCampaignUpdate']
    },
    {
        role: 'Head Of Sales',
        allowedRequests: []
    },
    {
        role: 'Trainer',
        allowedRequests: ['usersMovementRequest', 'userCampaignUpdate']
    },
    {
        role: 'Dialler',
        allowedRequests: ['campaignCreation']
    },
    {
        role: 'Admin',
        allowedRequests: ['usersMovementRequest', 'usersCreation', 'userCampaignUpdate', 'managerCampaignUpdate', 'updateAgentPersalInformation']
    }
]

export const GetRequestTypeAccess = ({ roleName }) => {
    // const roleExists = roleDictionary.some(role => role.value === roleName);
    const roleTypeAccess = requestTypeAccessByRole.find(role => role.role === roleName);
    let requestTypes = [];
    if (roleTypeAccess) {
        for (let index = 0; index < roleTypeAccess.allowedRequests.length; index++) {
            const request = roleTypeAccess.allowedRequests[index];

            let res = requestTypeDictionary.find(requestT => requestT.key === request);
            requestTypes.push(res);
        }
    }

    return requestTypes;
}